import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const ENROLLMENT_HISTORY_LATEST_LOG_EVENT_FIELDNAME = 'automation_ui_canvas_getLatestEnrollment';
export const FETCH_LATEST_ENROLLMENT_HISTORY_LOG_EVENT = registerQuery({
  fieldName: ENROLLMENT_HISTORY_LATEST_LOG_EVENT_FIELDNAME,
  args: ['flowId'],
  fetcher({
    flowId
  }) {
    return http.post('automationapps/v1/history/enrollments', {
      data: {
        flowId,
        startTimestamp: 0,
        limit: 1
      }
    });
  }
});
export const ENROLLMENT_HISTORY_LIST_FIELDNAME = 'automation_ui_canvas_getEnrollmentList';
export const FETCH_ENROLLMENT_HISTORY_LIST_FIELD_POLICY = {
  keyArgs: ['flowId', 'objectFilter', 'startTimestamp', 'endTimestamp', 'reachedActionIds'],
  merge(existing, incoming) {
    if (!existing) {
      return Object.assign({}, incoming);
    }
    const mergedResults = [...existing.results, ...incoming.results];
    const uniqueResults = [];
    const uniqueEnrollmentIds = new Set();
    // only merge unique enrollments
    mergedResults.forEach(enrollment => {
      if (!uniqueEnrollmentIds.has(enrollment.enrollmentId)) {
        uniqueEnrollmentIds.add(enrollment.enrollmentId);
        uniqueResults.push(enrollment);
      }
    });
    return Object.assign({}, incoming, {
      results: uniqueResults
    });
  }
};
export const FETCH_ENROLLMENT_HISTORY_LIST = registerQuery({
  fieldName: ENROLLMENT_HISTORY_LIST_FIELDNAME,
  args: ['flowId', 'objectFilter', 'startTimestamp', 'endTimestamp', 'reachedActionIds'],
  fetcher({
    flowId,
    objectFilter,
    offset,
    startTimestamp,
    endTimestamp,
    limit,
    reachedActionIds = [],
    seenEnrollmentIds = []
  }) {
    return http.post('automationapps/v1/history/enrollments', {
      data: {
        flowId,
        objectFilter,
        offset,
        startTimestamp,
        endTimestamp,
        limit,
        reachedActionIds,
        seenEnrollmentIds
      }
    });
  }
});